import { Box, Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { SelectOption } from 'components/form/Select/useSelect'
import { SelectWithSearch } from 'components/form/SelectWithSearch'
import { LeidButton } from 'components/ui/Buttons/Button'
import { ButtonServer } from 'components/ui/Buttons/Button/server'
import { Loader } from 'components/ui/Loader'
import LeidModal from 'components/ui/Modal/LeidModal'
import theme from 'styles/theme'
import { LocationInfo } from '../utils'

type LocationModalProps = {
  isOpen: boolean
  onClose: () => void
  selectedOption: SelectOption | undefined
  searchOptions: SelectOption[]
  locationLoading: boolean
  currentLocation: LocationInfo | undefined
  isLoggedIn: boolean
  onUseMyLocation: () => void
  onSearchTermChange: (search: string) => void
  onInputSelectChange: (value: SelectOption) => void
  onRedirectToLogin: () => void
}

export const LocationModal = ({
  isOpen,
  onClose,
  selectedOption,
  searchOptions,
  locationLoading,
  currentLocation,
  isLoggedIn,
  onUseMyLocation,
  onSearchTermChange,
  onInputSelectChange,
  onRedirectToLogin,
}: LocationModalProps) => {
  const { t } = useTranslation(['common', 'auth'])

  return (
    <LeidModal
      isOpen={isOpen}
      onClose={onClose}
      header={t('common:changeLocation')}
      size={{ base: 'cover', md: 'lg' }}
      scrollBehavior="outside"
    >
      <Text fontSize="md">{t('common:searchLocationText')}:</Text>

      <Box marginTop={10} marginBottom={8}>
        <ButtonServer onClick={onUseMyLocation} isDisabled={locationLoading}>
          {locationLoading ? <Loader size="md" isLight /> : t('common:useMyLocation')}
        </ButtonServer>

        {currentLocation?.error && (
          <Box>
            <Text color="red">{t('common:errorOnGettingTryAgain')}</Text>
          </Box>
        )}
      </Box>

      <Box>
        <SelectWithSearch
          name="select"
          defaultOption={selectedOption}
          options={searchOptions}
          onSearchTermChange={onSearchTermChange}
          onChange={onInputSelectChange}
          placeholder={t('common:searchByPostnumPlaceholder')}
          zIndex={theme.token.var('zIndex.max')}
        />
      </Box>

      {false && !isLoggedIn && (
        <Flex marginTop={30} marginBottom={10} direction="row" justifyContent="flex-end">
          <LeidButton onClick={onRedirectToLogin}>{t('auth:login')}</LeidButton>
        </Flex>
      )}
    </LeidModal>
  )
}
